// DayList.js
import React, { useState } from 'react';
import './WeekList.css';
import DayForm from './DayForm';
import editicon from "../../../images/edit-icon.svg";
import ContentForm from './ContentForm';
import { Close } from '@mui/icons-material';
import { add } from 'lodash';
import { addContentApi } from '../../services/educationService';
import './DayList.css'
const DayList = ({ days, weekId, weekNumber, handelDaySave, onHandleSaveContent, onDeleteContent }) => {

  const [selectedDay, setSelectedDay] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isContentModalOpen, setIsContentModalOpen] = useState(false);
  const handleEditClick = (day) => {
    setSelectedDay(day);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedDay(null);
  };

  const handleCloseContentModal = () => {
    setIsContentModalOpen(false)
  }

  const handleSaveContent = async (content, isEditing) => {

    const response = await addContentApi(content, isEditing);
    // update days data with new content
    onHandleSaveContent({ weekId, dayId: selectedDay._id, content: response });
    // setIsContentModalOpen(false)
  }



  const handleContentEditClick = (day) => {
    setSelectedDay(day);
    setIsContentModalOpen(true);
  };
  // content
  const [contents, setContents] = useState([
    {
      type: 'audio',
      title: 'Intro to AI',
      description: 'Basic explanation',
      content: '',
      audioFile: { name: 'intro.mp3' },
    },
    {
      type: 'text',
      title: 'Lesson Notes',
      description: 'Summary',
      content: 'This is the text content.',
    },
  ]);



  return (
    <>
      <div className="d-flex flex-wrap mt-2 gap-2">
        {days.map((day, index) => (
          <div key={index} className="day-card justify-content-between d-flex">
            <div className="day-title d-flex justify-content-between align-items-center">
              <span style={{ marginRight: 8, color: day.content ? '#28a745' : '#6c757d' }}>•   {`Day ${index + 1}`}</span>

              <a
                className="edit-del-icon eye-edit-del eye-img" onClick={() => handleEditClick(day)}  >
                <img src={editicon} alt="edit" />
              </a>

            </div>
            <div className='d-flex justify-content-between'>
              <div className={` day-status ${day?.contentLength > 0 ? 'status-ready' : 'status-empty'}`}>
                {day?.contentLength > 0 ? 'Content Ready' : 'No Content'}
              </div>

              <a onClick={() => handleContentEditClick(day)}
                className="edit-del-icon add-icon" data-bs-toggle="tooltip" data-bs-placement="top" title="Add Content" tooltip="Add Content" > +  </a>
            </div>

          </div>
        ))}
      </div>

      {/* handel day model here */}
      {isModalOpen && selectedDay && (
        <DayForm day={selectedDay} weekId={weekId} weekNumber={weekNumber} onClose={handleCloseModal} onSaveDay={handelDaySave} />
      )}
      {/* handel content model here */}
      {isContentModalOpen && (
        <ContentForm weekId={weekId} weekNumber={weekNumber} day={selectedDay} onClose={handleCloseContentModal} onSave={handleSaveContent} contents={contents} onDeleteContent={onDeleteContent} />
      )}
    </>
  );
};

export default DayList;
